/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 

export const IsJWT = (token) => {
    const parts = token.split('.');
    if (parts.length !== 3) {
        return false;
    }

    const isBase64Url = (str) => {
        const base64UrlPattern = /^[A-Za-z0-9-_]+$/;
        return base64UrlPattern.test(str);
    };

    const [header, payload, signature] = parts;

    return isBase64Url(header) && isBase64Url(payload) && isBase64Url(signature);
}